//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

// #region Imports
import { EthAddr, TxHash } from '@shared/SchemaTypes'
import { Contract, Signer } from 'ethers'

import { ActivityEnum, RoleEnum } from '@shared/Enums'

import { poolActions } from '@react/redux/poolSlice'

import { logOT } from '@shared/loggingShared'

import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'

import { assertRole, dispatchError, OtStoreState, useOtChainState } from '@react/redux/store'

import { PoolAbi } from '@shared/Abis'
import { ERC20Wei } from '@shared/conversions'

import { txUUID, wsServerActionPoolTX, wsServerActionPoolTXRequest } from '@shared/WsServerActions'

export const requestEarlyRedeemTx =
  (props: {
    poolAddr: EthAddr
    earlyWithdrawShares: ERC20Wei
  }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, _getState): Promise<void> => {
    const activity = ActivityEnum.EARLY_WITHDRAW_REQUEST

    try {
      const {
        webSocket,
        userConnection: { roleEnum, signer },
        chainConfiguration: { chainConfigurationName },
      } = useOtChainState()
      assertRole(roleEnum, RoleEnum.LENDER)

      const { poolAddr, earlyWithdrawShares } = props

      logOT.debug('acceptEarlyRedeemRequestSaga', poolAddr)

      await requestEarlyRedeem(webSocket, signer as Signer, poolAddr, earlyWithdrawShares, chainConfigurationName)

      dispatch(poolActions.requestEarlyRedeemSuccess(props))
    } catch (e: any) {
      dispatch(poolActions.requestEarlyRedeemFail(props))
      await dispatchError(dispatch, e, activity, 1016)
    } finally {
      const event = new Event('modalClose')
      window.dispatchEvent(event)
    }
  }
export const requestEarlyRedeem = async (
  webSocket: WebSocket | undefined,
  lenderSigner: Signer,
  poolAddr: EthAddr,
  earlyWithdrawShares: ERC20Wei,
  chainConfigurationName: string
): Promise<void> => {
  try {
    logOT.info('requestEarlyRedeem')

    const uuid = txUUID()
    webSocket?.send(
      wsServerActionPoolTXRequest(ActivityEnum.EARLY_WITHDRAW_REQUEST, poolAddr, uuid, chainConfigurationName)
    )

    const poolContract = new Contract(poolAddr, PoolAbi, lenderSigner)

    const tx = await poolContract.requestEarlyRedeem(earlyWithdrawShares)

    webSocket?.send(
      wsServerActionPoolTX(
        ActivityEnum.EARLY_WITHDRAW_REQUEST,
        poolAddr,
        uuid,
        tx.hash as TxHash,
        chainConfigurationName
      )
    )
    await tx.wait(1)

    logOT.info('requestEarlyRedeem tx', tx)
  } catch (error) {
    logOT.error(error)
  }
}
